import { Css, GridDataRow, Palette, Tag, Tooltip, useComputed, useGridTableApi } from "@homebound/beam";
import { createPlanDetailsUrl } from "src/RouteUrls";
import { StepLayout } from "src/components/stepper/StepLayout";
import { EditOptionsHeader } from "src/routes/developments/plan-and-options/options/components/EditOptionsHeader";
import { ChooseOptionsRowV1, ChooseOptionsStepBodyV1 } from "./components/ChooseOptionsStepBodyV1";

export function ChooseOptionsStep({ developmentId, id }: { developmentId: string; id: string }) {
  const tableApi = useGridTableApi<ChooseOptionsRowV1>();
  const selectedRows = useComputed(() => tableApi.getSelectedRows("globalOption"), [tableApi]);

  return (
    <StepLayout
      header={
        <EditOptionsHeader
          title="Choose Options"
          tooltip="Choose all Floorplan, Interior, and Add-On Options that you would like to be applicable for this Readyplan"
          subtitle="Choose which options are going to be part of the ready plan, then click Save."
          right={<SelectedOptionsTag selectedRows={selectedRows} />}
        />
      }
      body={
        <ChooseOptionsStepBodyV1
          planId={id}
          returnUrl={createPlanDetailsUrl(developmentId, id)}
          setStepDirty={() => {}}
          tableApi={tableApi}
        />
      }
    />
  );
}

function SelectedOptionsTag({ selectedRows }: { selectedRows: GridDataRow<ChooseOptionsRowV1>[] }) {
  const explodedRowsByLocation = selectedRows.flatMap((r) => r.data?.locations.map((loc) => ({ ...r, location: loc })));
  return (
    selectedRows.length > 0 && (
      <div css={Css.asfe.$}>
        <Tooltip
          bgColor={Palette.White}
          placement="bottom"
          title={
            <div css={Css.dg.gtc(`auto auto auto`).gap1.flexWrap("wrap").$}>
              {selectedRows.map(({ data: option }, idx) => {
                const numLocations = option?.locations.length ?? 0;
                return (
                  <Tag
                    key={option?.id ?? idx}
                    type="info"
                    text={
                      <span css={Css.xs2.$}>
                        {option?.code}
                        {numLocations > 1 ? <span css={Css.xs2Sb.$}> x{numLocations}</span> : ""}
                      </span>
                    }
                  />
                );
              })}
            </div>
          }
        >
          <Tag text={`${explodedRowsByLocation.length} options selected`} type="info" preventTooltip />
        </Tooltip>
      </div>
    )
  );
}
